module.exports = __webpack_public_path__ + "static/media/2.62aa9abd.jpg";